import { render, staticRenderFns } from "./Novel_Comments.vue?vue&type=template&id=7a437db0&scoped=true&"
import script from "./Novel_Comments.vue?vue&type=script&lang=js&"
export * from "./Novel_Comments.vue?vue&type=script&lang=js&"
import style0 from "./Novel_Comments.vue?vue&type=style&index=0&id=7a437db0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a437db0",
  null
  
)

export default component.exports